<ng-container>
	<base-display [alignment]="'left'" [smallLetters]="'CALL'" [bigLetters]="contact()" [unit]="" [showScale]="false"></base-display>
</ng-container>